module.exports = __webpack_public_path__ + "img/banner-mobile.1107985b.jpg";